import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { Journal } from 'services/action';

import { Page, Button } from 'ui/components';
import { FormGeneral, FormCoaes } from './component/form';

const initialState = {
  data: null,
  general: null,
  items: null,
  isLoading: true,
};

const UpdateScreen = ({ match }) => {
  const Dispatch = useDispatch();
  const History = useHistory();

  const StateForm = useSelector((state) => state?.Form);
  const isLoading = useSelector(
    (state) => state?.Activity?.services['Journal.Show']
  );

   const [{ general, items, data }, setState] =
    React.useState(initialState);

  const $onLoad = async (e) => {
    const req = await Dispatch(Journal.$show(e));

    if (req?.message === 'success') {
      setState((prevState) => ({
        ...prevState,
        data: req?.data,
      }));
    }
  };

  const $handleSubmit = async (e) => {
    const payload = {
      transaction_id: general?.transaction?.id,
      partner_id: general?.partner?.id,
      type: general?.type,
      ref_code: general?.ref_code,
      entry_at: general?.entry_at?.formatted,
      note: general?.note,
      is_adjustment: general?.is_adjustment,
      items
    };

    const req = await Dispatch(Journal.$update(data?.id, payload));

    if (req?.message === 'success') {
      History?.push(`/accounting/journal`);
    }
  };

  React.useEffect(() => {
    $onLoad(match?.params?.id);
  }, []);

  return (
    <Page type="form" onSubmit={$handleSubmit} className="detail-fixed">
      <Page.Header title="Perbaharui Journal" className="bg-light" />

      <Page.Body className="d-block row px-3">
        <FormGeneral
          data={data}
          onChange={(e) =>
            setState((prevState) => ({ ...prevState, general: e }))
          }
          items={items}
          isLoading={isLoading}
        />
        <FormCoaes
          isUseRef={true}
          data={data}
          transaction={general?.transaction}
          onChange={(e) =>
            setState((prevState) => ({ ...prevState, items: e }))
          }
          isLoading={isLoading}
        />
      </Page.Body>
      <Page.Footer className="bg-light justify-content-center gap-md-2 pt-2 pb-0 pb-md-3 mb-2 mb-md-0 border-top d-md-flex d-block flex-wrap">
        <Button
          type="button"
          className="btn-secondary py-md-2"
          onClick={() => {
            History.replace(`/accounting/journal`);
          }}
        >
          Batal &amp; Kembali
        </Button>
        <Button
          type="submit"
          loading={StateForm?.loading}
          className="btn-primary py-md-2"
        >
          Simpan
        </Button>
      </Page.Footer>
    </Page>
  );
};

export default UpdateScreen;
